/**
 * UUID v4, работающий и на insecure origin.
 * crypto.randomUUID доступен только в secure context (https или localhost), поэтому при
 * локальной разработке по http на IP машины его нет - там берем getRandomValues,
 * на который ограничение secure context не распространяется.
 */
export function randomUuid(): string {
	if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
		return crypto.randomUUID();
	}

	if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
		const bytes = crypto.getRandomValues(new Uint8Array(16));
		bytes[6] = (bytes[6] & 0x0f) | 0x40; // версия 4
		bytes[8] = (bytes[8] & 0x3f) | 0x80; // вариант RFC 4122
		const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');

		return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
	}

	return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}`;
}
